import { render, staticRenderFns } from "./fieldFile.vue?vue&type=template&id=508853f2&"
import script from "./fieldFile.vue?vue&type=script&lang=js&"
export * from "./fieldFile.vue?vue&type=script&lang=js&"
import style0 from "./fieldFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports